<script>
import Layout from '@layouts/loggedin.vue'
import { authComputed, authMethods } from '@state/helpers'
import store from '@state/store'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import VueTagsInput from '@johmun/vue-tags-input'
import ProductTile from '@marketplace/components/product-tile.vue'
import ProductDetails from '@marketplace/components/product-details.vue'
import ProductEdit from '@marketplace/components/product-edit.vue'
import ProductAdd from '@marketplace/components/product-add.vue'
import ProductDelete from '@marketplace/components/product-delete.vue'
import AdminTableItem from '@components/admin-table-item.vue'
import Treeselect from '@riophae/vue-treeselect'

export default {
  components: {
    Layout,
    Tab,
    Tabs,
    VueTagsInput,
    ProductTile,
    ProductDetails,
    ProductEdit,
    ProductAdd,
    ProductDelete,
    AdminTableItem,
    Treeselect,
  },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      hasNoData: false,
      category: '',
      categoryTag: '',
      categoryTags: [],
      autocompleteCategoryItems: [],
      tag: '',
      tagTag: '',
      tagTags: [],
      autocompleteTagItems: [],
      sort: '',
      singleProduct: null,
      singleEditProduct: null,
      singleDeleteProduct: null,
      showAddProduct: false,
      ordersFields: [
        {
          name: 'Order Date',
          class: 'table-cell align-middle w-1/12 pl-8 px-1',
          sortKey: 'created_at',
          displayField: 'created_at',
          sortOrder: ['desc', 'asc'],
        },
        {
          name: 'User',
          class: 'table-cell align-middle w-2/12 px-1',
          sortKey: 'user_name',
          displayField: 'user_name',
          sortOrder: ['desc', 'asc'],
        },
        {
          name: 'Email',
          class: 'table-cell align-middle w-3/12 px-1',
          sortKey: 'user_email',
          displayField: 'user_email',
          sortOrder: ['desc', 'asc'],
        },
        {
          name: 'Item',
          class: 'table-cell align-middle w-2/12 px-1',
          sortKey: 'product_title',
          displayField: 'product_title',
          sortOrder: ['desc', 'asc'],
        },
        {
          name: 'Cost',
          class: 'table-cell align-middle w-1/12 px-1',
          sortKey: 'total_price',
          displayField: 'total_price',
          sortOrder: ['desc', 'asc'],
        },
        {
          name: 'Quantity',
          class: 'table-cell align-middle w-1/12 px-1',
          sortKey: 'quantity',
          displayField: 'quantity',
          sortOrder: ['desc', 'asc'],
        },
        {
          name: 'Status',
          class: 'table-cell align-middle w-1/12 px-1',
          sortKey: 'status',
          displayField: 'status',
          sortOrder: ['desc', 'asc'],
        },
        {
          name: 'Status Date',
          class: 'table-cell align-middle w-1/12 px-1',
          sortKey: 'status_update_at',
          displayField: 'status_update_at',
          sortOrder: ['desc', 'asc'],
        },
      ],
      groupIds: this.selectedGroupIds,
      isStoreEnabled: this.selectedGroupIds,
      activeTab: 0,
    }
  },
  computed: {
    ...authComputed,
    groups() {
      return this.$store.state.marketplace.groups || []
    },
    currentCompany() {
      let currentCompany = false
      for (let index = 0; index < this.currentUser.companies.length; index++) {
        if (this.currentUser.companies[index].id === this.companyId) {
          currentCompany = this.currentUser.companies[index]
        }
      }
      return currentCompany
    },
    products() {
      return this.$store.state.marketplace.products || []
    },
    orders() {
      return this.$store.state.marketplace.orders || []
    },

    selectedGroupIds: {
      get: function() {
        var selectedGroups = []

        for (var i = this.currentCompany.groups.length - 1; i >= 0; i--) {
          if (this.currentCompany.groups[i].store_is_visible) {
            selectedGroups.push(this.currentCompany.groups[i].id)
          }
        }
        return selectedGroups
      },
      set: function(groupId) {
        this.groupIds = groupId
      },
    },
    storeIsEnabled: {
      get: function() {
        var is = 0
        if (this.currentCompany.store_status !== '') {
          is = 1
        }
        return is
      },
      set: function(is) {
        this.isStoreEnabled = is
      },
    },
  },
  watch: {
    categoryTag: 'initCategoryItems',
    tagTag: 'initTagItems',
    sort: 'filterProducts',
    isStoreEnabled: 'updateStoreSettings',
    groupIds: 'updateStoreSettings',
  },
  mounted() {
    this.initCategoryItems()
    this.initTagItems()
  },
  methods: {
    ...authMethods,
    updateStoreSettings() {
      store
        .dispatch('marketplace/saveStoreSettings', {
          companyId: this.currentCompany.id,
          storeIsEnabled:
            this.isStoreEnabled !== undefined
              ? this.isStoreEnabled
              : this.storeIsEnabled,
          enableGroupIds:
            this.groupIds !== undefined ? this.groupIds : this.selectedGroupIds,
        })
        .then((response) => {})
        .catch(() => console.warn('Oh. Something went wrong'))
    },
    filterProducts() {
      var params = []
      if (this.sort !== '') {
        params.sortby = this.sort
      }
      if (this.categoryTags.length > 0) {
        params.categories = this.categoryTags
      }
      if (this.tagTags.length > 0) {
        params.tags = this.tagTags
      }
      this.debounce = setTimeout(() => {
        store
          .dispatch('marketplace/fetchProducts', {
            companyId: this.currentCompany.id,
            params: params,
          })
          .then(() => {})
          .catch(() => console.warn('Oh. Something went wrong'))
      }, 500)
    },
    updateCategory(newTags) {
      // this.autocompleteCauseItems = []
      this.categoryTags = newTags
      this.filterProducts()
    },
    initCategoryItems() {
      store
        .dispatch('marketplace/fetchCategories', {
          companyId: this.currentCompany.id,
        })
        .then((response) => {
          this.autocompleteCategoryItems = response.map((a) => {
            return { text: a.name, id: a.id }
          })
        })
        .catch(() => console.warn('Oh. Something went wrong'))
    },
    updateTag(newTags) {
      // this.autocompleteCauseItems = []
      this.tagTags = newTags
      this.filterProducts()
    },
    initTagItems() {
      store
        .dispatch('marketplace/fetchTags', {
          companyId: this.currentCompany.id,
        })
        .then((response) => {
          this.autocompleteTagItems = response.map((a) => {
            return { text: a.name, id: a.id }
          })
        })
        .catch(() => console.warn('Oh. Something went wrong'))
    },
    closeModal() {
      this.singleProduct = null
    },
    closeEditModal() {
      this.singleEditProduct = null
    },
    closeAddModal() {
      this.showAddProduct = false
    },
    closeDeleteModal() {
      this.singleDeleteProduct = null
    },
    buyProduct(params) {
      store
        .dispatch('marketplace/buyProduct', {
          companyId: this.currentCompany.id,
          productId: params.product_id,
          quantity: params.quantity,
        })
        .then((response) => {
          store
            .dispatch('auth/boughtProduct', {
              order: response,
            })
            .then((response) => {
              this.closeModal()
            })
        })
        .catch(() => console.warn('Oh. Something went wrong'))
    },
    saveProduct(params) {
      store
        .dispatch('marketplace/saveProduct', {
          companyId: this.currentCompany.id,
          product: params,
        })
        .then((response) => {
          this.closeEditModal()
          this.closeAddModal()
        })
        .catch(() => console.warn('Oh. Something went wrong'))
    },
    deleteProduct(params) {
      store
        .dispatch('marketplace/deleteProduct', {
          companyId: this.currentCompany.id,
          productId: params.product_id,
        })
        .then((response) => {
          this.closeDeleteModal()
        })
        .catch(() => console.warn('Oh. Something went wrong'))
    },
    setSortParams(params) {
      store.dispatch('marketplace/sortOrders', {
        key: Object.keys(params)[0],
        order: params[Object.keys(params)[0]],
      })
    },
    updateOrderStatus(params) {
      store
        .dispatch('marketplace/updateOrderStatus', {
          companyId: this.currentCompany.id,
          orderId: params.orderId,
          newStatus: params.newStatus,
        })
        .then((response) => {})
        .catch(() => console.warn('Oh. Something went wrong'))
    },
    exportOrders() {
      // console.log('test')
    },
    changedTab(params) {
      this.activeTab = params.index
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white px-8 pt-4">
      <div class="text-black text-xl"
        >{{ currentCompany.name }} Marketplace</div
      >
      <div class="mt-5 text-center text-blue-darker text-4xl"
        >PENCIL Points Available:
        <span class="inline-block text-blue text-6xl">{{
          currentUser.funds
        }}</span></div
      >
      <div class="w-10/12 mt-8 mx-auto flex">
        <div class="w-1/3 flex-grow pl-2 pr-4">
          <label for="sort" class="block mb-3">Sort:</label>
          <select v-model="sort" class="select h-sm">
            <option value="">Select</option>
            <option value="price-asc">Price (low to high)</option>
            <option value="price-desc">Price (high to low)</option>
            <option value="title-asc">Alphabetically</option>
          </select>
        </div>
        <div class="w-1/3 flex-grow pl-4 pr-2">
          <label for="max_people" class="block mb-3">Category:</label>
          <VueTagsInput
            v-model="categoryTag"
            :tags="categoryTags"
            :autocomplete-items="autocompleteCategoryItems"
            :add-only-from-autocomplete="true"
            :add-on-blur="false"
            placeholder="Filter by Category"
            :autocomplete-min-length="0"
            class="mx-auto mb-8"
            @tags-changed="updateCategory"
          />
        </div>
        <div class="w-1/3 flex-grow pl-4 pr-2">
          <label for="min_age" class="block mb-3">Tag:</label>
          <VueTagsInput
            v-model="tagTag"
            :tags="tagTags"
            :autocomplete-items="autocompleteTagItems"
            :add-only-from-autocomplete="true"
            :add-on-blur="false"
            placeholder="Filter by Tag"
            :autocomplete-min-length="0"
            class="mx-auto mb-8"
            @tags-changed="updateTag"
          />
        </div>
      </div>
    </div>
    <button
      v-if="activeTab === 2 && canEditCompany(currentCompany.id)"
      class="button secondary-button h-12 inline-block text-right right-0 mr-8 mb-4 absolute"
      @click="exportOrders"
      >Export Orders</button
    >
    <button
      v-if="activeTab !== 2 && canEditCompany(currentCompany.id)"
      class="button primary-button h-12 inline-block text-right right-0 mr-8 mb-4 absolute"
      @click="showAddProduct = true"
      >+ Create Item</button
    >
    <ProductAdd
      v-if="showAddProduct && canEditCompany(currentCompany.id)"
      :current-company-id="currentCompany.id"
      @add-product="saveProduct"
      @close="closeAddModal"
    ></ProductAdd>
    <Tabs
      :classes="'flex justify-between'"
      :parent-classes="'w-content bg-white flex justify-center'"
      :tab-classes="
        'border-b-5 pb-5 text-xl mr-16 leading-loose cursor-pointer'
      "
      @changed-tab="changedTab"
    >
      <Tab title='<span class="align-middle">Store</span>'>
        <div
          class="h-auto flex events-grid mt-16 pl-15 pr-15 justify-start w-content"
        >
          <div
            v-for="product in products"
            :key="product.id"
            class="product-box-wrapper"
          >
            <ProductTile
              :product="product"
              @open-details="singleProduct = product"
            ></ProductTile>
          </div>
        </div>
        <ProductDetails
          v-if="singleProduct"
          :product="singleProduct"
          @buy-product="buyProduct"
          @close="closeModal"
        ></ProductDetails>
      </Tab>
      <Tab
        v-if="canEditCompany(currentCompany.id)"
        title='<span class="align-middle">Manage</span>'
      >
        <div
          class="h-auto flex events-grid mt-16 pl-15 pr-15 justify-start w-content"
        >
          <div
            v-for="product in products"
            :key="product.id"
            class="product-box-wrapper"
          >
            <ProductTile
              :product="product"
              :can-edit="true"
              @open-edit="singleEditProduct = product"
              @confirm-delete-product="singleDeleteProduct = product"
            ></ProductTile>
          </div>
        </div>
        <ProductEdit
          v-if="singleEditProduct"
          :product="singleEditProduct"
          @save-product="saveProduct"
          @close="closeEditModal"
        ></ProductEdit>
        <ProductDelete
          v-if="singleDeleteProduct"
          :product="singleDeleteProduct"
          @delete-product="deleteProduct"
          @close="closeDeleteModal"
        ></ProductDelete>
      </Tab>
      <Tab
        v-if="canEditCompany(currentCompany.id)"
        title='<span class="align-middle">Orders</span>'
      >
        <div class="h-auto flex mt-16 pl-15 pr-15 justify-center">
          <div class="bg-white w-full pt-4 px-8 pb-12 rounded-xl shadow-box">
            <BaseTableHeader
              :header-data="ordersFields"
              @set-sort-params="setSortParams"/>
            <div class="table w-full">
              <div v-if="loading" class="w-full text-center py-24">
                Loading...
              </div>
              <div v-if="hasNoData" class="w-full text-center py-24">
                No data.
              </div>
              <AdminTableItem
                v-for="item in orders"
                :key="item.id"
                :item-data="item"
                :table-fields="ordersFields"
                @update-order-status="updateOrderStatus"
              /> </div></div
        ></div>
      </Tab>
      <Tab
        v-if="!canEditCompany(currentCompany.id)"
        title='<span class="align-middle">My Orders</span>'
      >
        <div class="h-auto flex mt-16 pl-15 pr-15 justify-center">
          <div class="bg-white w-full pt-4 px-8 pb-12 rounded-xl shadow-box">
            <BaseTableHeader
              :header-data="ordersFields"
              @set-sort-params="setSortParams"/>
            <div class="table w-full">
              <div v-if="loading" class="w-full text-center py-24">
                Loading...
              </div>
              <div v-if="hasNoData" class="w-full text-center py-24">
                No data.
              </div>
              <AdminTableItem
                v-for="item in orders"
                :key="item.id"
                :item-data="item"
                :table-fields="ordersFields"
                @update-order-status="updateOrderStatus"
              /> </div></div
        ></div>
      </Tab>
      <Tab
        v-if="canEditCompany(currentCompany.id)"
        title='<span class="align-middle">Settings</span>'
      >
        <div class="h-auto flex mt-16 pl-15 pr-15 justify-center">
          <div class="bg-white w-full pt-4 px-8 pb-12 rounded-xl shadow-box">
            <div class="w-7/12 mx-auto">
              <div class="mt-4 text-2xl text-blue-darker"
                >Marketplace Availability</div
              >
              <div class="mt-4">
                <label
                  for="store_is_enabled"
                  class="text-basel text-black cursor-pointer align-middle relative flex"
                >
                  <input
                    id="store_is_enabled"
                    :checked="storeIsEnabled === 1"
                    type="radio"
                    name="store_is_enabled"
                    class="radio mr-2 mt-1"
                    value="1"
                    @change="isStoreEnabled = 1"
                  />
                  <div class="radio-checked"></div>
                  Open
                </label>
              </div>
              <div class="mt-4">
                <label
                  for="store_is_disabled"
                  class="text-basel text-black cursor-pointer align-middle relative flex"
                >
                  <input
                    id="store_is_disabled"
                    :checked="storeIsEnabled === 0"
                    type="radio"
                    name="store_is_enabled"
                    class="radio mr-2 mt-1"
                    value="0"
                    @change="isStoreEnabled = 0"
                  />
                  <div class="radio-checked"></div>
                  Closed
                </label>
              </div>

              <div class="mt-4">
                <label
                  for="store_is_disabled"
                  class="text-basel text-black cursor-pointer align-middle relative flex"
                  >Marketplace Visibility:</label
                >
                <Treeselect
                  v-model="selectedGroupIds"
                  :options="groups"
                  :multiple="true"
                  :flat="true"
                  name="groups"
                  value-consists-of="BRANCH_PRIORITY"
                >
                  <label slot="option-label" slot-scope="{ node }">
                    {{ node.raw.name }}
                  </label>
                  <div slot="value-label" slot-scope="{ node }">{{
                    node.raw.name
                  }}</div>
                </Treeselect>
              </div>
            </div>
          </div></div
        >
      </Tab>
    </Tabs>
  </Layout>
</template>
